<div class="kt-container-fixed space-y-12 h-full">
  @if (transaction.isTransactionPaid() || transaction.hasBoletoLink()) {
    <app-message-card
      icon="check"
      [subHeading]="transaction.isBoletoPending() ? 'Boleto disponível!' : 'Transação concluída!'"
    >
      <div class="space-y-4 text-center">
        @if (transaction.hasBoletoLink() && transaction.isBoletoPending()) {
          <p>O boleto foi gerada com sucesso e pode ser acessada clicando no botão abaixo.</p>
          <a class="kt-btn" [href]="transaction.boletoLink()" target="_blank" rel="noopener noreferrer">
            Visualizar boleto
          </a>
        } @else {
          Seu pagamento foi confirmado com sucesso e a transação foi concluída.
        }
      </div>
    </app-message-card>
  } @else if (transaction.isFraudAnalysisReview()) {
    <app-message-card subHeading="Pagamento em análise">
      <p class="text-sm text-gray-700 text-center">
        Estamos processando as informações passadas e iremos entrar em contato em caso de falha.
      </p>
    </app-message-card>
  } @else if (transaction.error()) {
    <app-message-card
      icon="abstract-11"
      variant="error"
      subHeading="Algo saiu errado!"
    >
      <div class="text-center">
        {{errorMessage()}}
      </div>
    </app-message-card>
  } @else {
    <div>
      <h1 class="text-xl font-medium text-gray-900">Pagamento</h1>
      <p class="text-sm text-gray-700">Realize o pagamento de maneira prática e segura conforme as opções disponívels.</p>
    </div>

    @if (showPixStep()) {
      <app-payment-finish [payment]="paymentInfo()" />
    } @else {
      @if (isCreditCard() && threeDSService.isEnabled()) {
        <app-bpmpi-form
          [tokenResponse]="threeDSService.token.value() ?? null"
          [orderId]="transaction.resource.value()?.Id ?? ''"
          [cardNumber]="creditCardForm.controls.cardNumber.value"
          [validThru]="creditCardForm.controls.validThru.value"
          [installments]="installments() || 1"
          [totalAmount]="transaction.resource.value()?.TotalAmount ?? 0"
          [products]="transaction.resource.value()?.Products ?? []"
        />
      }
      <app-payment-form
        [isLoading]="transaction.isLoading()"
        [transaction]="transaction.resource.value()!"
        [paymentMethodForm]="paymentMethodForm"
        [creditCardForm]="creditCardForm"
        [isCreditCard]="isCreditCard()"
        [selectedInstallmentNumber]="installments()"
        [hasPaymentMethod]="hasPaymentMethod()"
        [onSubmit]="onSubmit"
        [isSubmitting]="isSubmitting()"
        [threeDSBlocking]="threeDSBlocking()"
      />
    }
  }
</div>
